import "babel-polyfill"

NodeList.prototype.forEach = Array.prototype.forEach



// WEBPACK FOOTER //
// ./src/polyfills.js